/* eslint-disable import/no-mutable-exports */
const env = process.env.REACT_APP_ENV;
let envValues = {
  PORT: 80,
  REACT_APP_API_ENDPOINT: 'http://localhost:4080/v2',
  REACT_APP_API_FRONT_END: 'http://localhost:4080',
  REACT_APP_API_PERMISSION_DENIED: 'http://localhost:4080/permission',
  REACT_APP_SHOW_COOKIE_BOX: false,
  SOCKET_STATUS: 'OFF',
  COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
};
switch (env) {
  case 'staging':
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: 'https://api-marq.iscriptsdemo.com/v2',
      REACT_APP_API_FRONT_END: 'https://api-marq.iscriptsdemo.com',
      REACT_APP_API_PERMISSION_DENIED: 'https://api-marq.iscriptsdemo.com/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'OFF',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
    };
    break;
  case 'production':
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: 'https://api.marqevents.com/v2',
      REACT_APP_API_FRONT_END: 'https://api.marqevents.com',
      REACT_APP_API_PERMISSION_DENIED: 'https://eventadmin.marqevents.com/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'OFF',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
    };
    break;
  case 'development':
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: 'http://localhost:4080/v2',
      REACT_APP_API_FRONT_END: 'http://localhost:4080',
      REACT_APP_API_PERMISSION_DENIED: 'http://localhost:3000/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'OFF',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
    };
    break;
  case 'uat':
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: 'https://api-uat.marqevents.com/v2',
      REACT_APP_API_FRONT_END: 'https://api-uat.marqevents.com',
      REACT_APP_API_PERMISSION_DENIED: 'https://eventadmin-uat.marqevents.com/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'OFF',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
    };
    break;
  default:
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: 'http://localhost:4080/v2',
      // REACT_APP_API_ENDPOINT: 'https://api-marq.iscriptsdemo.com/v2',
      REACT_APP_API_FRONT_END: 'http://localhost:4080',
      REACT_APP_API_PERMISSION_DENIED: 'http://localhost:3000/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'OFF',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
    };
    break;
}

export default envValues;
